const React = require('react');
const isNode = (typeof process !== 'undefined');
const CSSTransitionGroup = isNode ? require('react-transition-group/CSSTransitionGroup') : () => null;
const LargeLogo = require('../LargeLogo');
const SmallLogo = require('../SmallLogo');
const SearchIcon = require('../SearchIcon');

class DesktopMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            headerHeight: null,
            minimizedMenuVisible: false,
            compressed: this.props.config.compressed,
            hoverActive: null
        };

        this.checkforHeaderChange = this.checkforHeaderChange.bind(this);
        this.setHeaderSize = this.setHeaderSize.bind(this);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
    }

    setHeaderSize() {
        try {
            this.setState({
                headerHeight: this.refs.header.clientHeight,
            });
        } catch(e) {

        }
    }

    checkforHeaderChange() {
        const { headerHeight } = this.state;
        let minimized = false;
        if (headerHeight && (window.pageYOffset >= headerHeight)) {
            minimized = true;
        }

        this.setState({
            minimizedMenuVisible: minimized
        });
    }

    componentDidMount() {
        const { compressed } = this.state;
        if (!compressed) {
            window.addEventListener('scroll', this.checkforHeaderChange);
            window.addEventListener('scroll', this.setHeaderSize);
            this.checkforHeaderChange();
        }
        window.addEventListener('resize', this.setHeaderSize);
        this.setHeaderSize();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.checkforHeaderChange);
        window.removeEventListener('scroll', this.setHeaderSize);
    }

    mouseEnter(i) {
        this.setState({
            hoverActive: i
        })
    }

    mouseLeave(i) {
        this.setState({
            hoverActive: null
        })
    }

    renderSubMenu(item) {
        if (!item.children.length) return null;
        return (
        <ul className="desktop-menu__sub-menu">
            {item.children.map(child => {
                return (
                <li className="desktop-menu__sub-item">
                    <a className="desktop-menu__sub-anchor" href={child.link}>{(child.menuName) ? child.menuName : child.displayName}</a>
                </li>
                )
            })}
        </ul>
        )
    }

    render() {
        const { menuItems } = this.props;
        const { minimizedMenuVisible, compressed } = this.state;

        const lis = menuItems.map((item, i) => {
            const anchorClasses = [].concat('desktop-menu__anchor', item.isActive ? 'desktop-menu__anchor--active' : null, item.children.length ? 'hasChildren' : null).join(' ');
            const listClasses = [].concat('desktop-menu__list-item', (this.state.hoverActive !== null) ? 'desktop-menu__list-item--hover' : null, (this.state.hoverActive === i) ? 'desktop-menu__list-item--hover-active' : null).join(' ');

            {return item.isDropDown ? (
                <li className={listClasses} key={i} onMouseEnter={() => this.mouseEnter(i)} onMouseLeave={this.mouseLeave}>
                    <a className={anchorClasses}>{(item.menuName) ? item.menuName : item.displayName}</a>
                    {(this.state.hoverActive === i) && this.renderSubMenu(item)}
                </li>
                ) : (
               <li className={listClasses} key={i} onMouseEnter={() => this.mouseEnter(i)} onMouseLeave={this.mouseLeave}>
                   <a href={item.externalLink ? item.externalLink : item.link} className={anchorClasses}>{(item.menuName) ? item.menuName : item.displayName}</a>
               </li>
           )}

        });

        return (
        <header className="desktop-menu" ref="header">
            <div>
                {compressed && <div className="desktop-menu__spacer"></div>}

                {!compressed && (
                <div className="desktop-menu__large-container">
                    <a href={this.props.frontpageUrl}>
                        <LargeLogo className="desktop-menu__logo"/>
                    </a>
                    <nav className="desktop-menu__nav">
                        <ul className="desktop-menu__list">
                            {lis}
                            <li className="desktop-menu__list-item" onClick={() => this.props.toggleSearch()}><SearchIcon className="desktop-menu__search"/></li>
                        </ul>
                    </nav>
                </div>
                )}

                {(compressed || minimizedMenuVisible) && (
                <CSSTransitionGroup
                transitionName={compressed ? 'no-transition' : 'minimized-menu'}
                transitionAppear={true}
                transitionAppearTimeout={500}
                transitionEnter={false}
                transitionLeave={false}>
                    <nav className="desktop-menu__nav desktop-menu__nav--minimized">
                        <a href={this.props.frontpageUrl}>
                            <SmallLogo className="desktop-menu__small-logo"/>
                        </a>
                        <a onClick={() => this.props.toggleSearch()} className="desktop-menu__search-icon"><SearchIcon /></a>
                        <ul className="desktop-menu__list">
                            {lis}
                        </ul>
                    </nav>
                </CSSTransitionGroup>
                )}
            </div>
        </header>
        )
    }
}

module.exports = DesktopMenu;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/DesktopMenu/index.jsx